import { Plugin } from '@nuxt/types'

const paymentPlugin: Plugin = ({ $accessor, $auth, $sentry }) => {
  if ($auth.loggedIn && !$accessor.account.isActivePro && window.ppsdk) {
    window.ppsdk.onError($sentry.captureException)
    window.ppsdk.preload()

    window.ppsdk.onSuccess(() => {
      window.ppsdk.onClose(() => {
        window.location.reload()
      })
    })
  }
}

export default paymentPlugin
